import { defineStore } from 'pinia'

export const useEventsStore = defineStore('eventsStore', () => {
  const events = ref([])
  const selectedEventId = ref(null)
  const eventPreviewImages = ref({})

  const latestEvent = computed(() => events.value[0] ?? null)

  const currentSelectedEventId = computed(() => selectedEventId.value ?? events.value[0]?.id)

  const hasOnlyMomentshareDriveEvents = computed(() => events.value.every((event) => event.hasMomentshareUpgrade))

  const hasOnlyDemoEvent = computed(() => events.value.every((event) => event.isDemo))

  const demoEvent = computed(() => events.value.find((event) => event.isDemo))

  function getEventPreviewImages(id) {
    return eventPreviewImages.value[id] ?? null
  }

  /**
   * @param {string} id
   * @returns {momentshare.models.event.Event|undefined}
   */
  function getEventById(id) {
    return events.value.find((event) => event.id === id)
  }

  function reset() {
    selectedEventId.value = null
    events.value = []
  }

  /**
   * @param {momentshare.models.event.Event[]} [newEvents]
   * @returns {void}
   */
  function setEvents(newEvents) {
    events.value = newEvents ?? []
  }

  /**
   * @param {string} id
   * @returns {void}
   */
  function setSelectedEventId(id) {
    selectedEventId.value = id
  }

  function setEventPreviewImages(id, images) {
    eventPreviewImages.value[id] = images
  }

  /**
   * Owner-only QR style written back from the qr-style endpoints.
   * @param {string} eventId
   * @param {QrStyle|null} qrStyle normalised style (see ~/lib/mappers/event-mapper mapQrStyle)
   */
  function setEventQrStyle(eventId, qrStyle) {
    const event = getEventById(eventId)

    if (event) {
      event.qrStyle = qrStyle
    }
  }

  /**
   * Owner-only album QR style written back from the album qr-style endpoints.
   * @param {string} eventId
   * @param {string} albumId
   * @param {QrStyle|null} qrStyle normalised style, null = follows the event
   */
  function setAlbumQrStyle(eventId, albumId, qrStyle) {
    const album = getEventById(eventId)?.albums?.find((candidate) => candidate.id === albumId)

    if (album) {
      album.qrStyle = qrStyle
    }
  }

  return {
    events,
    selectedEventId,
    eventPreviewImages,
    latestEvent,
    currentSelectedEventId,
    hasOnlyMomentshareDriveEvents,
    hasOnlyDemoEvent,
    demoEvent,
    getEventPreviewImages,
    getEventById,
    reset,
    setEvents,
    setSelectedEventId,
    setEventPreviewImages,
    setEventQrStyle,
    setAlbumQrStyle,
  }
})
